import {useContext} from 'react';
import {GlobalImageCacheContext} from '@contexts';

export const useGlobalImageCache = () => {
  return useContext(GlobalImageCacheContext);
};
